import { useMemo } from 'react';
import { TipCardConfig, TipCardState } from '../types/tipcard';
import { calculateTipCardPlacements, shouldRenderTipAt } from '../utils/tipCardPlacement';

export function useTipCardPlacement(
  configs: TipCardConfig[],
  tipCardState: TipCardState,
  sectionItemCounts: {
    destaque: number;
    para_voce: number;
    outros: number;
  }
) {
  const placements = useMemo(
    () => calculateTipCardPlacements(configs, tipCardState, sectionItemCounts),
    [configs, tipCardState, sectionItemCounts]
  );

  const getTipAtPosition = (
    section: 'destaque' | 'para_voce' | 'outros',
    itemIndex: number
  ) => {
    return shouldRenderTipAt(section, itemIndex, placements);
  };

  return { placements, getTipAtPosition };
}
